
export const addDays = (day: Date, days: number): Date => {
    const unixdate = Date.parse(day.toString());
    var date = new Date(unixdate);
    date.setDate(date.getDate() + days);
    return date;
}

export const FormatDoyAndYear = (date: Date): string => {
    if (date === undefined) {
        return "";
    }

    const forceDate = new Date(date); // getFullYear fails half the time otherwise
    const doy = DoyFromDate(date);
    const year = forceDate.getFullYear();
    return year.toString() + " - " + doy.toString();
}

// Convert a Day Of Year (doy) from a number (with decimal) to a date/time for the 
// given year specified
export const DateFromDoy = (year: number, day: number): Date => {
    var date = new Date(year, 0); // initialize a date in `year-01-01`
    date.setDate(Math.floor(day)); // add the number of days_viable

    var seconds = (day % 1) * 86400
    date.setSeconds(seconds)

    return date;
}

// Also we need to be able to convert a Date/Time to a Day Of Year (doy) including
// decimal places to represent the time portion. Keeping in mind we are only being
// precise to 2 decimal places fro this result.
export const DoyFromDate = (date: Date): number => {
    if (date === undefined) {
        return 0;
    }

    const forceDate = new Date(date); // getFullYear fails half the time otherwise
    const start = new Date(forceDate.getFullYear(), 0, 0);
    const diff = (forceDate.valueOf() - start.valueOf()) + ((start.getTimezoneOffset() - forceDate.getTimezoneOffset()) * 60 * 1000);
    const oneDay = 1000 * 60 * 60 * 24;
    var day = diff / oneDay;
    return parseFloat(day.toFixed(2))
}

// This should ONLY return the Day portion. We don't care about the decimal portion.
// Also we are ignoring timezone as part of the calculation because it doens't matter.
export const MaxDoyForYear = (year: number): number => {
    if (year < 0) { return -1; }

    return (Date.UTC(year, 11, 31) - Date.UTC(year, 0, 0)) / 24 / 60 / 60 / 1000;
}

// Split an array of dates into it's multiple ranges (at the Day level of 
// separation by removing the time component). This is for when we have 
// shedding or application events for calendar display that have a gap in 
// between so we can turn it into multiple multi-day calendar events instead 
// of a single that may mis-represent.
export const DateRanges = (dates: Date[]): Date[][] => {
    let x: Date[][] = [];
    if (dates.length === 0) {
        return x;
    }

    // convert to unix times for easier calculations
    // Also strip the time portion of the date/time
    const timestamps: number[] = dates.map(x => new Date(new Date(x).toDateString()).getTime());
    const unique: number[] = Array.from(new Set(timestamps)).sort();
    const first_day: number = unique.reduce((min, i) => i < min ? i : min, unique[0]);
    const last_day: number = unique.reduce((max, i) => i >= max ? i : max, unique[0]);

    const fastCheck = addDays(new Date(first_day), unique.length - 1).getTime();
    if (fastCheck === last_day) {
        x.push(unique.map(x => new Date(x)));
        return x;
    }

    let arrayIndex: number = 0;
    let currentArray: Date[] = [];
    let last: number = first_day;
    for (let i = 0; i < unique.length; i++) {
        if (x.length < arrayIndex) {
            x.push([]);
        }

        const lastDate = new Date(last);
        const current = unique[i];
        const currentDate = new Date(current);
        if (currentDate <= addDays(lastDate, 1)) {
            currentArray.push(currentDate);
        } else {
            x[arrayIndex] = currentArray;
            currentArray = [currentDate];
            arrayIndex++;
        }

        last = current;
    }

    x[arrayIndex] = currentArray;

    return x;
};